import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _72b92925 = () => interopDefault(import('../pages/certification.vue' /* webpackChunkName: "pages/certification" */))
const _66a31c3a = () => interopDefault(import('../pages/class.vue' /* webpackChunkName: "pages/class" */))
const _a36e7bb4 = () => interopDefault(import('../pages/class/index.vue' /* webpackChunkName: "pages/class/index" */))
const _763e55c8 = () => interopDefault(import('../pages/class/closed.vue' /* webpackChunkName: "pages/class/closed" */))
const _48860aaa = () => interopDefault(import('../pages/config/index.vue' /* webpackChunkName: "pages/config/index" */))
const _523c59a3 = () => interopDefault(import('../pages/documents.vue' /* webpackChunkName: "pages/documents" */))
const _d9b7b8ce = () => interopDefault(import('../pages/errorsBook.vue' /* webpackChunkName: "pages/errorsBook" */))
const _6138ab04 = () => interopDefault(import('../pages/exam.vue' /* webpackChunkName: "pages/exam" */))
const _e2112e88 = () => interopDefault(import('../pages/exam/correction/index.vue' /* webpackChunkName: "pages/exam/correction/index" */))
const _5df13102 = () => interopDefault(import('../pages/exam/distribute/index.vue' /* webpackChunkName: "pages/exam/distribute/index" */))
const _34d1f4ac = () => interopDefault(import('../pages/exam/exams/index.vue' /* webpackChunkName: "pages/exam/exams/index" */))
const _160de058 = () => interopDefault(import('../pages/exam/correction/correct.vue' /* webpackChunkName: "pages/exam/correction/correct" */))
const _517a2a59 = () => interopDefault(import('../pages/exam/correction/correct/_id/coments.vue' /* webpackChunkName: "pages/exam/correction/correct/_id/coments" */))
const _28147bdf = () => interopDefault(import('../pages/exam/correction/correct/_id/exam.vue' /* webpackChunkName: "pages/exam/correction/correct/_id/exam" */))
const _29eec26c = () => interopDefault(import('../pages/exam/correction/selectExam/_id.vue' /* webpackChunkName: "pages/exam/correction/selectExam/_id" */))
const _84ff2bb8 = () => interopDefault(import('../pages/exam/correction/_id.vue' /* webpackChunkName: "pages/exam/correction/_id" */))
const _41f73da7 = () => interopDefault(import('../pages/exam/distribute/_id.vue' /* webpackChunkName: "pages/exam/distribute/_id" */))
const _5308d997 = () => interopDefault(import('../pages/exam/exams/_id/index.vue' /* webpackChunkName: "pages/exam/exams/_id/index" */))
const _18b89cd6 = () => interopDefault(import('../pages/exam/ranking/_id.vue' /* webpackChunkName: "pages/exam/ranking/_id" */))
const _7bd75ab0 = () => interopDefault(import('../pages/exam/exams/_id/result.vue' /* webpackChunkName: "pages/exam/exams/_id/result" */))
const _73256c63 = () => interopDefault(import('../pages/exam/exams/_id/review.vue' /* webpackChunkName: "pages/exam/exams/_id/review" */))
const _ef58a55a = () => interopDefault(import('../pages/exam/exams/_id/send.vue' /* webpackChunkName: "pages/exam/exams/_id/send" */))
const _04402d27 = () => interopDefault(import('../pages/exam/exams/_id/start.vue' /* webpackChunkName: "pages/exam/exams/_id/start" */))
const _15d6fcda = () => interopDefault(import('../pages/finance_dashboard.vue' /* webpackChunkName: "pages/finance_dashboard" */))
const _c0f61046 = () => interopDefault(import('../pages/finance_dashboard/index.vue' /* webpackChunkName: "pages/finance_dashboard/index" */))
const _20fb2251 = () => interopDefault(import('../pages/finance_dashboard/anticipations.vue' /* webpackChunkName: "pages/finance_dashboard/anticipations" */))
const _1f26679d = () => interopDefault(import('../pages/finance_dashboard/transactions/index.vue' /* webpackChunkName: "pages/finance_dashboard/transactions/index" */))
const _4ab22b0c = () => interopDefault(import('../pages/finance_dashboard/transactions/extract.vue' /* webpackChunkName: "pages/finance_dashboard/transactions/extract" */))
const _9e113286 = () => interopDefault(import('../pages/IA.vue' /* webpackChunkName: "pages/IA" */))
const _8dcda900 = () => interopDefault(import('../pages/IA/index.vue' /* webpackChunkName: "pages/IA/index" */))
const _5e8153cc = () => interopDefault(import('../pages/IA/chat.vue' /* webpackChunkName: "pages/IA/chat" */))
const _a18725d2 = () => interopDefault(import('../pages/materials.vue' /* webpackChunkName: "pages/materials" */))
const _2df2865a = () => interopDefault(import('../pages/materials/index.vue' /* webpackChunkName: "pages/materials/index" */))
const _484236a1 = () => interopDefault(import('../pages/materials/_catId/_subId.vue' /* webpackChunkName: "pages/materials/_catId/_subId" */))
const _7a2c791d = () => interopDefault(import('../pages/megecast/index.vue' /* webpackChunkName: "pages/megecast/index" */))
const _f9280008 = () => interopDefault(import('../pages/messagewall.vue' /* webpackChunkName: "pages/messagewall" */))
const _133ed870 = () => interopDefault(import('../pages/painel_dinamico/index.vue' /* webpackChunkName: "pages/painel_dinamico/index" */))
const _cba6467c = () => interopDefault(import('../pages/planning.vue' /* webpackChunkName: "pages/planning" */))
const _4e5d49c5 = () => interopDefault(import('../pages/planning/index.vue' /* webpackChunkName: "pages/planning/index" */))
const _f618ee42 = () => interopDefault(import('../pages/planning/config.vue' /* webpackChunkName: "pages/planning/config" */))
const _44606c25 = () => interopDefault(import('../pages/planning/legacy_create.vue' /* webpackChunkName: "pages/planning/legacy_create" */))
const _6914bd78 = () => interopDefault(import('../pages/planning/legacy_id.vue' /* webpackChunkName: "pages/planning/legacy_id" */))
const _2fb2d48e = () => interopDefault(import('../pages/planning/legacy_index.vue' /* webpackChunkName: "pages/planning/legacy_index" */))
const _0702663c = () => interopDefault(import('../pages/planning/legacy_processing.vue' /* webpackChunkName: "pages/planning/legacy_processing" */))
const _c5ab6cee = () => interopDefault(import('../pages/resultados.vue' /* webpackChunkName: "pages/resultados" */))
const _f85ed518 = () => interopDefault(import('../pages/resultados/_id/comparativo.vue' /* webpackChunkName: "pages/resultados/_id/comparativo" */))
const _6052ad38 = () => interopDefault(import('../pages/resultados/_id/geral.vue' /* webpackChunkName: "pages/resultados/_id/geral" */))
const _716fe29c = () => interopDefault(import('../pages/resultados/_id/questions.vue' /* webpackChunkName: "pages/resultados/_id/questions" */))
const _bd41af40 = () => interopDefault(import('../pages/simulados.vue' /* webpackChunkName: "pages/simulados" */))
const _7cf8323a = () => interopDefault(import('../pages/simulados/index.vue' /* webpackChunkName: "pages/simulados/index" */))
const _70ecfd1f = () => interopDefault(import('../pages/simulados/gabarito-comentado.vue' /* webpackChunkName: "pages/simulados/gabarito-comentado" */))
const _6acfd764 = () => interopDefault(import('../pages/simulados/simulatedResult.vue' /* webpackChunkName: "pages/simulados/simulatedResult" */))
const _0121f032 = () => interopDefault(import('../pages/simulados/ranking/_id.vue' /* webpackChunkName: "pages/simulados/ranking/_id" */))
const _ee8750f0 = () => interopDefault(import('../pages/suport.vue' /* webpackChunkName: "pages/suport" */))
const _77fb180b = () => interopDefault(import('../pages/suport/index.vue' /* webpackChunkName: "pages/suport/index" */))
const _556acd4f = () => interopDefault(import('../pages/suport/resolved.vue' /* webpackChunkName: "pages/suport/resolved" */))
const _7daa6a7d = () => interopDefault(import('../pages/videos.vue' /* webpackChunkName: "pages/videos" */))
const _52ea5f40 = () => interopDefault(import('../pages/videos/index.vue' /* webpackChunkName: "pages/videos/index" */))
const _2717e9bf = () => interopDefault(import('../pages/videos/_catId/_id.vue' /* webpackChunkName: "pages/videos/_catId/_id" */))
const _d66ce496 = () => interopDefault(import('../pages/applySimulated/print.vue' /* webpackChunkName: "pages/applySimulated/print" */))
const _90d2511a = () => interopDefault(import('../pages/config/password.vue' /* webpackChunkName: "pages/config/password" */))
const _461771e1 = () => interopDefault(import('../pages/config/payment/index.vue' /* webpackChunkName: "pages/config/payment/index" */))
const _0cbc7624 = () => interopDefault(import('../pages/config/perfil.vue' /* webpackChunkName: "pages/config/perfil" */))
const _1e32b44c = () => interopDefault(import('../pages/config/payment/_id/index.vue' /* webpackChunkName: "pages/config/payment/_id/index" */))
const _a8d35838 = () => interopDefault(import('../pages/megecast/play/_id.vue' /* webpackChunkName: "pages/megecast/play/_id" */))
const _2300cf86 = () => interopDefault(import('../pages/config/payment/_id/card.vue' /* webpackChunkName: "pages/config/payment/_id/card" */))
const _72989ef8 = () => interopDefault(import('../pages/config/payment/_id/failure.vue' /* webpackChunkName: "pages/config/payment/_id/failure" */))
const _6032ce8e = () => interopDefault(import('../pages/config/payment/_id/history.vue' /* webpackChunkName: "pages/config/payment/_id/history" */))
const _dd5ba248 = () => interopDefault(import('../pages/config/payment/_id/pix/index.vue' /* webpackChunkName: "pages/config/payment/_id/pix/index" */))
const _183ec06e = () => interopDefault(import('../pages/config/payment/_id/refund.vue' /* webpackChunkName: "pages/config/payment/_id/refund" */))
const _262e871e = () => interopDefault(import('../pages/config/payment/_id/refund/index.vue' /* webpackChunkName: "pages/config/payment/_id/refund/index" */))
const _7eb50734 = () => interopDefault(import('../pages/config/payment/_id/refund/confirmation.vue' /* webpackChunkName: "pages/config/payment/_id/refund/confirmation" */))
const _0e19253c = () => interopDefault(import('../pages/config/payment/_id/refund/success.vue' /* webpackChunkName: "pages/config/payment/_id/refund/success" */))
const _42a41b30 = () => interopDefault(import('../pages/config/payment/_id/refund/tracking.vue' /* webpackChunkName: "pages/config/payment/_id/refund/tracking" */))
const _1def2477 = () => interopDefault(import('../pages/config/payment/_id/refund/question/_order.vue' /* webpackChunkName: "pages/config/payment/_id/refund/question/_order" */))
const _00c24b06 = () => interopDefault(import('../pages/config/payment/_id/success.vue' /* webpackChunkName: "pages/config/payment/_id/success" */))
const _74a7a56a = () => interopDefault(import('../pages/config/payment/_id/unsubscribe.vue' /* webpackChunkName: "pages/config/payment/_id/unsubscribe" */))
const _3f5360e4 = () => interopDefault(import('../pages/config/payment/_id/unsubscribe/index.vue' /* webpackChunkName: "pages/config/payment/_id/unsubscribe/index" */))
const _cc42c2ae = () => interopDefault(import('../pages/config/payment/_id/unsubscribe/confirmation.vue' /* webpackChunkName: "pages/config/payment/_id/unsubscribe/confirmation" */))
const _716ea582 = () => interopDefault(import('../pages/config/payment/_id/unsubscribe/success.vue' /* webpackChunkName: "pages/config/payment/_id/unsubscribe/success" */))
const _6edef72f = () => interopDefault(import('../pages/config/payment/_id/pix/expired.vue' /* webpackChunkName: "pages/config/payment/_id/pix/expired" */))
const _28c9f10d = () => interopDefault(import('../pages/config/payment/_id/pix/success.vue' /* webpackChunkName: "pages/config/payment/_id/pix/success" */))
const _48200b7c = () => interopDefault(import('../pages/applySimulated/_id.vue' /* webpackChunkName: "pages/applySimulated/_id" */))
const _36ef9250 = () => interopDefault(import('../pages/painel_dinamico/_id.vue' /* webpackChunkName: "pages/painel_dinamico/_id" */))
const _c5be9786 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _efcbfdd6 = () => interopDefault(import('../pages/*.vue' /* webpackChunkName: "pages/*" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/certification",
    component: _72b92925,
    name: "certification"
  }, {
    path: "/class",
    component: _66a31c3a,
    children: [{
      path: "",
      component: _a36e7bb4,
      name: "class"
    }, {
      path: "closed",
      component: _763e55c8,
      name: "class-closed"
    }]
  }, {
    path: "/config",
    component: _48860aaa,
    name: "config"
  }, {
    path: "/documents",
    component: _523c59a3,
    name: "documents"
  }, {
    path: "/errorsBook",
    component: _d9b7b8ce,
    name: "errorsBook"
  }, {
    path: "/exam",
    component: _6138ab04,
    name: "exam",
    children: [{
      path: "correction",
      component: _e2112e88,
      name: "exam-correction"
    }, {
      path: "distribute",
      component: _5df13102,
      name: "exam-distribute"
    }, {
      path: "exams",
      component: _34d1f4ac,
      name: "exam-exams"
    }, {
      path: "correction/correct",
      component: _160de058,
      name: "exam-correction-correct",
      children: [{
        path: ":id?/coments",
        component: _517a2a59,
        name: "exam-correction-correct-id-coments"
      }, {
        path: ":id?/exam",
        component: _28147bdf,
        name: "exam-correction-correct-id-exam"
      }]
    }, {
      path: "correction/selectExam/:id?",
      component: _29eec26c,
      name: "exam-correction-selectExam-id"
    }, {
      path: "correction/:id",
      component: _84ff2bb8,
      name: "exam-correction-id"
    }, {
      path: "distribute/:id",
      component: _41f73da7,
      name: "exam-distribute-id"
    }, {
      path: "exams/:id",
      component: _5308d997,
      name: "exam-exams-id"
    }, {
      path: "ranking/:id?",
      component: _18b89cd6,
      name: "exam-ranking-id"
    }, {
      path: "exams/:id/result",
      component: _7bd75ab0,
      name: "exam-exams-id-result"
    }, {
      path: "exams/:id/review",
      component: _73256c63,
      name: "exam-exams-id-review"
    }, {
      path: "exams/:id/send",
      component: _ef58a55a,
      name: "exam-exams-id-send"
    }, {
      path: "exams/:id/start",
      component: _04402d27,
      name: "exam-exams-id-start"
    }]
  }, {
    path: "/finance_dashboard",
    component: _15d6fcda,
    children: [{
      path: "",
      component: _c0f61046,
      name: "finance_dashboard"
    }, {
      path: "anticipations",
      component: _20fb2251,
      name: "finance_dashboard-anticipations"
    }, {
      path: "transactions",
      component: _1f26679d,
      name: "finance_dashboard-transactions"
    }, {
      path: "transactions/extract",
      component: _4ab22b0c,
      name: "finance_dashboard-transactions-extract"
    }]
  }, {
    path: "/IA",
    component: _9e113286,
    children: [{
      path: "",
      component: _8dcda900,
      name: "IA"
    }, {
      path: "chat",
      component: _5e8153cc,
      name: "IA-chat"
    }]
  }, {
    path: "/materials",
    component: _a18725d2,
    children: [{
      path: "",
      component: _2df2865a,
      name: "materials"
    }, {
      path: ":catId/:subId?",
      component: _484236a1,
      name: "materials-catId-subId"
    }]
  }, {
    path: "/megecast",
    component: _7a2c791d,
    name: "megecast"
  }, {
    path: "/messagewall",
    component: _f9280008,
    name: "messagewall"
  }, {
    path: "/painel_dinamico",
    component: _133ed870,
    name: "painel_dinamico"
  }, {
    path: "/planning",
    component: _cba6467c,
    children: [{
      path: "",
      component: _4e5d49c5,
      name: "planning"
    }, {
      path: "config",
      component: _f618ee42,
      name: "planning-config"
    }, {
      path: "legacy_create",
      component: _44606c25,
      name: "planning-legacy_create"
    }, {
      path: "legacy_id",
      component: _6914bd78,
      name: "planning-legacy_id"
    }, {
      path: "legacy_index",
      component: _2fb2d48e,
      name: "planning-legacy_index"
    }, {
      path: "legacy_processing",
      component: _0702663c,
      name: "planning-legacy_processing"
    }]
  }, {
    path: "/resultados",
    component: _c5ab6cee,
    name: "resultados",
    children: [{
      path: ":id?/comparativo",
      component: _f85ed518,
      name: "resultados-id-comparativo"
    }, {
      path: ":id?/geral",
      component: _6052ad38,
      name: "resultados-id-geral"
    }, {
      path: ":id?/questions",
      component: _716fe29c,
      name: "resultados-id-questions"
    }]
  }, {
    path: "/simulados",
    component: _bd41af40,
    children: [{
      path: "",
      component: _7cf8323a,
      name: "simulados"
    }, {
      path: "gabarito-comentado",
      component: _70ecfd1f,
      name: "simulados-gabarito-comentado"
    }, {
      path: "simulatedResult",
      component: _6acfd764,
      name: "simulados-simulatedResult"
    }, {
      path: "ranking/:id?",
      component: _0121f032,
      name: "simulados-ranking-id"
    }]
  }, {
    path: "/suport",
    component: _ee8750f0,
    children: [{
      path: "",
      component: _77fb180b,
      name: "suport"
    }, {
      path: "resolved",
      component: _556acd4f,
      name: "suport-resolved"
    }]
  }, {
    path: "/videos",
    component: _7daa6a7d,
    children: [{
      path: "",
      component: _52ea5f40,
      name: "videos"
    }, {
      path: ":catId/:id?",
      component: _2717e9bf,
      name: "videos-catId-id"
    }]
  }, {
    path: "/applySimulated/print",
    component: _d66ce496,
    name: "applySimulated-print"
  }, {
    path: "/config/password",
    component: _90d2511a,
    name: "config-password"
  }, {
    path: "/config/payment",
    component: _461771e1,
    name: "config-payment"
  }, {
    path: "/config/perfil",
    component: _0cbc7624,
    name: "config-perfil"
  }, {
    path: "/config/payment/:id",
    component: _1e32b44c,
    name: "config-payment-id"
  }, {
    path: "/megecast/play/:id?",
    component: _a8d35838,
    name: "megecast-play-id"
  }, {
    path: "/config/payment/:id/card",
    component: _2300cf86,
    name: "config-payment-id-card"
  }, {
    path: "/config/payment/:id/failure",
    component: _72989ef8,
    name: "config-payment-id-failure"
  }, {
    path: "/config/payment/:id/history",
    component: _6032ce8e,
    name: "config-payment-id-history"
  }, {
    path: "/config/payment/:id/pix",
    component: _dd5ba248,
    name: "config-payment-id-pix"
  }, {
    path: "/config/payment/:id/refund",
    component: _183ec06e,
    children: [{
      path: "",
      component: _262e871e,
      name: "config-payment-id-refund"
    }, {
      path: "confirmation",
      component: _7eb50734,
      name: "config-payment-id-refund-confirmation"
    }, {
      path: "success",
      component: _0e19253c,
      name: "config-payment-id-refund-success"
    }, {
      path: "tracking",
      component: _42a41b30,
      name: "config-payment-id-refund-tracking"
    }, {
      path: "question/:order?",
      component: _1def2477,
      name: "config-payment-id-refund-question-order"
    }]
  }, {
    path: "/config/payment/:id/success",
    component: _00c24b06,
    name: "config-payment-id-success"
  }, {
    path: "/config/payment/:id/unsubscribe",
    component: _74a7a56a,
    children: [{
      path: "",
      component: _3f5360e4,
      name: "config-payment-id-unsubscribe"
    }, {
      path: "confirmation",
      component: _cc42c2ae,
      name: "config-payment-id-unsubscribe-confirmation"
    }, {
      path: "success",
      component: _716ea582,
      name: "config-payment-id-unsubscribe-success"
    }]
  }, {
    path: "/config/payment/:id/pix/expired",
    component: _6edef72f,
    name: "config-payment-id-pix-expired"
  }, {
    path: "/config/payment/:id/pix/success",
    component: _28c9f10d,
    name: "config-payment-id-pix-success"
  }, {
    path: "/applySimulated/:id?",
    component: _48200b7c,
    name: "applySimulated-id"
  }, {
    path: "/painel_dinamico/:id",
    component: _36ef9250,
    name: "painel_dinamico-id"
  }, {
    path: "/",
    component: _c5be9786,
    name: "index"
  }, {
    path: "/*",
    component: _efcbfdd6,
    name: "*"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
